import styled from "styled-components";

export const Content = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 45px 35px;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  border: 1px solid #ddd;

  input {
    background: #fff;
  }

  a {
    color: #999;
    font-size: 14px;
    margin-top: 15px;
  }
`;
